// extracted by mini-css-extract-plugin
export default {"description":"Heading_description__U099Q","display":"Heading_display__gy+rs","title":"Heading_title__DRuEJ","heading":"Heading_heading__iU9N9"};